import React from 'react'
import {
    Select,
    Form,
    Button
} from 'antd'

import { 
    SendOutlined
} from '@ant-design/icons'

import useEnqueueReport from './useEnqueueReport'

export const pad = (n: any, width: any, z = '0') => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default function ReportFolderExchange() {
    const { enqueue, submitting: loading } = useEnqueueReport('exchanges')
    const [form] = Form.useForm()

    const { Option } = Select

    /**
     * @todo Get from API.
     */
    const allYearsAvailable = [
        { value: '2019', label: '2019'},
        { value: '2020', label: '2020'},
        { value: '2021', label: '2021' },
        { value: '2022', label: '2022' },
        { value: '2023', label: '2023' },
        { value: '2024', label: '2024' },
        { value: '2025', label: '2025' },
    ]

    const onFinish = (data: any) => {
        enqueue(data)
    }

    return <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} initialValues={{
        year: `${new Date().getFullYear()}`
    }}>
        <p>Puedes solicitar el informe sobre las carpetas de importacion ingresadas, recepcionadas y valorizadas.</p>
        <br />
        <Form.Item name="year" label="Año">
            <Select
                disabled={loading}
            >
            {allYearsAvailable.map(yearAv => (
                <Option value={yearAv.value} key={yearAv.value}>{yearAv.label}</Option>
            ))}
            </Select>
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} icon={<SendOutlined />} className='Accounting--DownloadBtn' >
          Solicitar Informe
        </Button>
    </Form>
}
